export const TYPE_INVALID = 'invalid';
export const TYPE_NEGATIVE = 'negative';
export const TYPE_CALLBACK = 'callback';
export const TYPE_POSITIVE = 'positive';

//const TYPES = [TYPE_INVALID, TYPE_NEGATIVE, TYPE_CALLBACK, TYPE_POSITIVE];

export const TYPES_INFO = {
  [TYPE_INVALID]: {
    title: 'Afvoeren/Invalid',
    info:
      'a number is no longer valid, the person will no longer come back in de cal list of the agent. In the reporting he will come back.'
  },
  [TYPE_NEGATIVE]: {
    title: 'Negative',
    info: '(the persons gives a negative answer towards the proposition)'
  },
  [TYPE_CALLBACK]: {
    title: 'Callback',
    info:
      'satus that we have to give a callback – if we have contact/email the agent can choose when he wants the callback day and time), the donor will come automatically back on that date and time to one of the agents assigned to the project. When there was no contact the donor comes back automatically'
  },
  [TYPE_POSITIVE]: {
    title: 'Positive',
    info: 'Positive'
  }
};

export const ACTIONS = [
  {
    label: 'Invalid Wrong Number',
    action: 'invalid_wrong_number',
    type: TYPE_INVALID,
    confirm: true
  },
  {
    label: 'Invalid No Number',
    action: 'invalid_no_number',
    type: TYPE_INVALID,
    confirm: true
  },
  // { label: 'Deactivated', action: 'deactivated', type: TYPE_NEGATIVE },
  {
    label: 'Negative Budget',
    action: 'negative_budget',
    type: TYPE_NEGATIVE,
    comments: true,
    called: true
  },
  {
    label: 'Negative Polydonor',
    action: 'negative_polydonor',
    type: TYPE_NEGATIVE,
    comments: true,
    called: true
  },
  {
    label: 'Negative Too Old',
    action: 'negative_too_old',
    type: TYPE_NEGATIVE,
    comments: true,
    called: true
  },
  {
    label: 'Negative No Reason',
    action: 'negative_no_reason',
    type: TYPE_NEGATIVE,
    comments: true,
    called: true
  },
  {
    label: 'Negative Unhappy About NGO',
    action: 'negative_unhappy_about_ngo',
    type: TYPE_NEGATIVE,
    comments: true,
    called: true
  },
  {
    label: 'Negative Other',
    action: 'negative_other',
    type: TYPE_NEGATIVE,
    comments: true,
    called: true
  },
  {
    label: 'Callback Unavailable',
    action: 'callback_unavailable',
    comments: true,
    type: TYPE_CALLBACK
  },
  {
    label: 'Callback Voicemail',
    action: 'callback_voicemail',
    comments: true,
    type: TYPE_CALLBACK
  },
  {
    label: 'Callback Short Contact',
    action: 'callback_short_contact',
    type: TYPE_CALLBACK,
    comments: true,
    called: true,
    callbackSchedule: true
  },
  {
    label: 'Callback Motivated Conversation',
    action: 'callback_motivated_conversation',
    type: TYPE_CALLBACK,
    comments: true,
    called: true,
    callbackSchedule: true
  },
  {
    label: 'Callback Followup Email',
    action: 'callback_followup_email',
    type: TYPE_CALLBACK,
    comments: true,
    called: true,
    callbackSchedule: true
  },
  {
    label: 'Positive Agreement',
    action: 'positive_agreement',
    type: TYPE_POSITIVE,
    comments: true,
    called: true
  },
  {
    label: 'Positive Gift',
    action: 'positive_gift',
    type: TYPE_POSITIVE,
    comments: true,
    called: true
  },
  {
    label: 'Positive Meeting',
    action: 'positive_meeting',
    type: TYPE_POSITIVE,
    comments: true,
    called: true
  }
];

const actionGetter = action => action.action;
const getActionsForType = actionType =>
  ACTIONS.filter(action => action.type === actionType).map(actionGetter);

export const STATUSES = ACTIONS.map(actionGetter);

export const STATUSES_POSITIVE = getActionsForType(TYPE_POSITIVE);
export const STATUSES_NEGATIVE = getActionsForType(TYPE_NEGATIVE);
export const STATUSES_INVALID = getActionsForType(TYPE_INVALID);
export const STATUSES_CALLBACK_SCHEDULE = getActionsForType(TYPE_CALLBACK);

export const STATUSES_CALLBACK_NO_SCHEDULE = ACTIONS.filter(
  action => action.type === TYPE_CALLBACK && action.callbackSchedule !== true
).map(actionGetter);

export const STATUSES_CALLED = ACTIONS.filter(action => action.called).map(
  actionGetter
);

export const STATUSES_WITH_CONFIRM = ACTIONS.filter(
  action => action.confirm
).map(actionGetter);

export const STATUSES_WITH_COMMENTS = ACTIONS.filter(
  action => action.comments
).map(actionGetter);

export const isWithConfirm = action =>
  STATUSES_WITH_CONFIRM.indexOf(action) > -1;



// WEBPACK FOOTER //
// ./src/helpers/contacts.js